/**
 * Pass tract entry - mount подписочного Vue-острова (Business Pass).
 *
 * Канон checkout.js: конфиг data-атрибутами с mount-ноды (volt пишет),
 * vendor-chunk общий - volt линкует ['vendor','pass'].
 */
import { createApp } from 'vue';
import http from './plugins/http';
import SubscribeApp from '../components/Checkout/SubscribeApp.vue';

const mount = document.getElementById('pass-app');

if( mount ) {

    const {
        subscriptionSlug,
        tier,
        price,
        trialEnd,
        isAuth,
        userEmail,
        successUrl,
        accountUrl
    } = mount.dataset;

    const app = createApp( SubscribeApp, {
        subscriptionSlug : subscriptionSlug || '',
        tier             : tier || 'trial',
        price            : parseInt( price, 10 ) || 0,
        trialEnd         : trialEnd || '',
        isAuth           : isAuth === '1',
        userEmail        : userEmail || '',
        successUrl       : successUrl || '/subscribe/success/',
        accountUrl       : accountUrl || '/account',
    } );

    app.use(http);
    app.mount( mount );
}